export default __webpack_public_path__ + "static/media/19.5g28mmvb.148b4809.jpeg";